import { Component,OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { LoginService } from './login.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  submitted = false;
  errorMessage = '';
  constructor(private formBuilder: FormBuilder,private router: Router,private loginService:LoginService) {
    this.loginForm = this.formBuilder.group({
      userName: ['', Validators.required],
      password: ['', Validators.required]
    });
  }


  ngOnInit(): void {
  }
   // Getter for easy access to form fields
   get f() { return this.loginForm.controls; }

   onSubmit() {
     this.submitted = true;
 
     if (this.loginForm.invalid) {
      Swal.fire("Please Enter Valid Credentials!")
      return console.log("invalid")
    }

    this.loginService.login(this.loginForm.value).subscribe((response: any) => {
      if (response) {


  //   let response={
  //     "message": "Success",
  //     "data": {
  //         "_id": "66b20ff6324ee5bd1d5cde17",
  //         "name": "Athira vinod",
  //         "phoneNumber": "1234567890",
  //         "whatsAppNumber": "0987654321",
  //         "password": "$2a$10$oli7I49CgTpOZqZl9Oj.SOouOgBV2cpBxGL86JsB.WXO83c0pKori",
  //         "photo": "http://example.com/photo.jpg",
  //         "address": "123 Main St, Anytown, USA",
  //         "email": "athira@gmail.com",
  //         "userName": "athira123",
  //         "employeeCode": "2024/08/06-EMP01",
  //         "accessToken": "",
  //         "agencyRefId": "66ae06bf8a841df42183d6c7",
  //         "isActive": true,
  //         "isDeleted": false,
  //         "userType": null,
  //         "createdAt": "2024-08-06T11:58:46.183Z",
  //         "updatedAt": "2024-08-06T12:08:46.492Z",
  //         "__v": 0
  //     },
  //     "token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2NmIyMGZmNjMyNGVlNWJkMWQ1Y2RlMTciLCJ1c2VyTmFtZSI6ImF0aGlyYTEyMyIsImlhdCI6MTcyMjk0NjQ2MSwiZXhwIjoxNzIzMTE5MjYxfQ.IDeSPPJ5fIZG8EFbFh-FUGxH8EYnboPro1_DTf-1dx8",
  //     "status": 1
  // }






    localStorage.setItem('token', response.token);






    // this.router.navigate(["/main-dashboard"])













        console.log(response)
        if (response.status == 1) {
          Swal.fire({
            title: 'Success!',
            text: 'Your action was successful!',
            icon: 'success',
            confirmButtonText: 'Cool'
          });
          this.router.navigate(["/main-dashboard"])
          localStorage.setItem("user", JSON.stringify(response.data))

        }

        
        else if (response.status == 2) {
          Swal.fire({
            title: 'Are you sure?',
            text: response.errorDetails + ' , logout all other sessions ? ',
            icon: 'warning',
          })
            .then(willDelete => {

              if (willDelete.isConfirmed == true) {


                let storedData = JSON.parse(localStorage.getItem("user") || '{}');


                let data = {
                  "userId": storedData._id || null
                };


              
                this.loginService.logOut(data, "").subscribe((res: any) => {
                  if (res.status == 1) {
                    this.router.navigate(['/login']);
                  }
                });


              }
            })
        }
      
      
      
      
      
      
      
      
      
      
      
      
      
      }})

    
      }
}
